// Public and signed URLs identify the same object. Never drop its folder prefix.
export function storageObjectPath(url: string, bucket: string, publicBaseUrl: string): string {
  // URL normalizes dot segments, so reject them before that normalization too.
  if (url.split(/[?#]/)[0].split('/').some(part => ['.', '..'].includes(decodeURIComponent(part)))) {
    throw new Error('Invalid storage object path');
  }
  const source = new URL(url);
  const base = new URL(publicBaseUrl);
  if (source.origin !== base.origin || source.username || source.password || !['https:', 'http:'].includes(source.protocol)) {
    throw new Error('Storage URL does not belong to this project');
  }
  const prefixes = ['public', 'sign', 'authenticated'].map(mode => `/storage/v1/object/${mode}/${encodeURIComponent(bucket)}/`);
  const prefix = prefixes.find(value => source.pathname.startsWith(value));
  if (!prefix) throw new Error('Storage URL does not belong to this bucket');
  const segments = source.pathname.slice(prefix.length).split('/').map(decodeURIComponent);
  if (segments.some(segment => !segment || segment === '.' || segment === '..' || /[\\/\u0000-\u001f]/.test(segment))) {
    throw new Error('Invalid storage object path');
  }
  return segments.join('/');
}
